import { useMemo } from 'react';
import type { LegalSchema, LegalValues } from '@/api/types';
import { countryName } from '@/lib/contour';

/**
 * Requisites inputs rendered from the contour's schema: ИНН/КПП/ОГРН in the RU
 * contour, country/registration number/VAT id/address lines in the main one.
 * The server checks formats; the form only marks what is required.
 */
export function RequisitesFields({ legal, values, onChange, markRequired = true }: { legal: LegalSchema; values: LegalValues; onChange: (key: string, value: string) => void; markRequired?: boolean }) {
  const countries = useMemo(() => (legal.countries ?? []).map((code) => ({ code, name: countryName(code) })).sort((a, b) => a.name.localeCompare(b.name, 'ru')), [legal.countries]);
  return (
    <>
      {legal.fields.map((f) => {
        const label = (
          <span className="mb-1.5 block text-muted">
            {f.label}
            {markRequired && f.required && <span aria-hidden> *</span>}
          </span>
        );
        const value = values[f.key] ?? '';
        return (
          <label key={f.key} className={`block text-sm ${f.wide ? 'sm:col-span-2' : ''}`}>
            {label}
            {f.kind === 'country' ? (
              <select className="field" name={f.key} value={value} required={markRequired && f.required} onChange={(e) => onChange(f.key, e.target.value)}>
                <option value="">Выберите страну</option>
                {countries.map((c) => (
                  <option key={c.code} value={c.code}>
                    {c.name}
                  </option>
                ))}
              </select>
            ) : (
              <input className={f.numeric ? 'field num' : 'field'} name={f.key} value={value} inputMode={f.numeric ? 'numeric' : undefined} required={markRequired && f.required} onChange={(e) => onChange(f.key, e.target.value)} />
            )}
            {f.hint && <span className="mt-1 block text-xs text-faint">{f.hint}</span>}
          </label>
        );
      })}
    </>
  );
}
